import { JsonObject } from '../app/json/jsonValue.js';

export class DynamicResults {
    dynamicDataResults: JsonObject = new JsonObject();
    dynamicViewResults: JsonObject = new JsonObject();
    dynamicActionResults: JsonObject = new JsonObject();
    // DynamicClientData RAW island set. Value = JsonObject. Separate from dynamicDataResults so the raw client
    // set never mixes into the server-baked DataJson; the same value later feeds the Embedded island and the
    // on-demand slice.
    // INTENTIONALLY double-purposed (do NOT split — the client re-emit must reproduce the server's page-tail
    // island byte-for-byte, so both writers share this one map):
    // - SERVER produce (applyDynamicClientDataHandlers): key = "ComponentName_<IClientDataType>" (the handler
    //   IType), written from the preparer's raw output.
    // - CLIENT re-emit (applyClientHandlers): key = "ComponentName_<ClientDataKey>" (derived from the
    //   declaration Name), written from the consumed delivered island.
    // A given merge runs one tier, so this map carries whichever tier ran, under that tier's key derivation.
    // This map holds only the RAW island; the consumer's FILTERED output is tracked separately in
    // dynamicClientResults.
    dynamicClientDataResults: JsonObject = new JsonObject();
    // DynamicClient CONSUMER outputs (FILTERED set the browser-side IClient produced from the raw island):
    // Key = "ComponentName_ClientDataKey", Value = JsonObject. The client-tier counterpart to
    // dynamicClientDataResults (the raw preparer set) — populated by applyClientHandlers on the clientMode
    // re-merge so the round-trip can cross-check every engine's consumer output.
    dynamicClientResults: JsonObject = new JsonObject();
    resolvedTemplateJson: JsonObject = new JsonObject();

    constructor() {}
}
